module.exports = __webpack_public_path__ + "img/Bodice-Back-Jb-Kd-Lc.999be803.png";